var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h16v16H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.012 0C7.558 0 8 .35 8 .779l-.009 5.229L13.221 6c.397 0 .724.376.773.864l.006.124c0 .547-.347.99-.777.991l-5.235.009-.009 5.235c0 .397-.379.724-.867.771L6.988 14C6.442 14 6 13.65 6 13.221l.008-5.23L.778 8c-.396 0-.723-.376-.772-.864L0 7.012c0-.547.347-.99.777-.991l5.235-.009.009-5.235c0-.397.379-.724.867-.771z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.29561213caf6f4f3183b7e1ecbab8928.svg";
export { ForwardRef as ReactComponent };